/**
 * Enum represent type name of step navigation
 */
export var SubmitButtonType;
(function (SubmitButtonType) {
    SubmitButtonType["PreviousStep"] = "PreviousStep";
    SubmitButtonType["NextStep"] = "NextStep";
})(SubmitButtonType || (SubmitButtonType = {}));
